var _circle, _circle2, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShortlist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#feffff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "none",
    strokeWidth: 2,
    stroke: "#191919"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.13 15.59h-.06c-2.1.01-4.06 1.08-5.2 2.85a6.222 6.222 0 00-5.2-2.85h-.06c-3.4.03-6.13 2.79-6.13 6.19.14 2.63 1.05 5.16 2.62 7.27 2.54 3.19 5.49 6.04 8.77 8.45 3.29-2.41 6.24-5.26 8.77-8.45 1.57-2.11 2.48-4.64 2.62-7.27 0-3.4-2.74-6.16-6.13-6.19z",
    stroke: "#000",
    strokeMiterlimit: 10,
    fill: "none",
    strokeWidth: 2
  })));
}

export default __webpack_public_path__ + "1ef020cb55d898254f8afaa8725d6cab.svg";
export { SvgShortlist as ReactComponent };